// services/ReferenceValueService.js
import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";

export function getReferenceValues(params = {}) {
    return api.get(ENDPOINTS.REFERENCE_VALUES.BASE, { params });
}
export function getReferenceValueById(id) {
    return api.get(ENDPOINTS.REFERENCE_VALUES.BY_ID(id));
}
export function createReferenceValue(payload) {
    return api.post(ENDPOINTS.REFERENCE_VALUES.BASE, payload);
}
export function updateReferenceValue(id, payload) {
    return api.patch(ENDPOINTS.REFERENCE_VALUES.BY_ID(id), payload);
}
export function deleteReferenceValue(id) {
    return api.delete(ENDPOINTS.REFERENCE_VALUES.BY_ID(id));
}
export function restoreReferenceValue(id) {
    return api.post(`${ENDPOINTS.REFERENCE_VALUES.BY_ID(id)}/restore`);
}
